import type { CityConfig } from "../city-template/types";

export const losAlamosConfig: CityConfig = {
  city: "Los Alamos",
  state: "New Mexico",
  stateAbbr: "NM",
  slug: "los-alamos",
  route: "/los-alamos",
  title: "Emergency Passport Los Alamos, NM — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Los Alamos, NM — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving LANL scientists, NNSA contractors, international researchers, and Los Alamos County families.",
  h1: "Emergency & Expedited Passport Services in Los Alamos, NM",
  heroSubtitle: "LANL international collaboration meeting at CERN next week? NNSA contractor deploying to an overseas facility on short notice? Postdoc fellowship starting at a European university and your passport is expired? We help Los Alamos residents — from LANL scientists and engineers to NNSA contractors to White Rock families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Los%20Alamos%20New%20Mexico%20at%20golden%20hour%20with%20the%20Jemez%20Mountains%20rising%20majestically%20in%20the%20background%2C%20the%20Pajarito%20Plateau%20mesa%20top%20community%20visible%20with%20pine%20forest%20surrounding%2C%20modern%20laboratory%20buildings%20and%20residential%20areas%20nestled%20among%20ponderosa%20pines%2C%20dramatic%20high%20desert%20mountain%20landscape%20with%20warm%20golden%20light%2C%20professional%20travel%20photography%20with%20rich%20green%20pine%20and%20warm%20terracotta%20tones&width=1800&height=700&seq=los-alamos-hero-2026&orientation=landscape",
  heroImageAlt: "Los Alamos New Mexico on the Pajarito Plateau with Jemez Mountains at golden hour",
  geoPosition: "35.8801;-106.3026",
  geoPlacename: "Los Alamos, New Mexico",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "El Paso Passport Agency",
    address: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
    distance: "Located in downtown El Paso, TX — approximately 330 miles south of Los Alamos. Appointments required, typically booked 2+ weeks out. The nearest passport agency serving the region.",
  },
  nearbyCitiesZips: [
    { name: "Los Alamos", zips: "87544, 87545" },
    { name: "White Rock", zips: "87547" },
    { name: "Espanola", zips: "87532, 87533" },
    { name: "Santa Fe", zips: "87501–87508" },
    { name: "Pojoaque", zips: "87506" },
    { name: "Nambe", zips: "87506" },
    { name: "Tesuque", zips: "87574" },
    { name: "Chimayo", zips: "87522" },
    { name: "Abiquiu", zips: "87510" },
    { name: "Albuquerque (closest major airport & agency hub)", zips: "87101–87199" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Los Alamos Emergency Processing", desc: "Reserved courier access — as fast as 24 hours for Los Alamos-area travelers with immediate departures. No need to drive 330 miles to El Paso or waste days on agency appointment logistics." },
    { icon: "ri-microscope-line", title: "LANL & National Laboratory Specialist", desc: "Los Alamos National Laboratory is one of the world's premier scientific institutions. We handle expedited passports for LANL scientists, postdocs, NNSA contractors, and international collaborators with tight conference, collaboration, and deployment timelines." },
    { icon: "ri-flight-takeoff-line", title: "Albuquerque & Santa Fe Airport Connections", desc: "Los Alamos County Airport (LAM) offers limited service. Most international travelers use Albuquerque International Sunport (ABQ, ~100 miles) or Santa Fe Regional (SAF, ~40 miles). We coordinate timing around your departure airport." },
    { icon: "ri-global-line", title: "International Research & Exchange Ready", desc: "LANL hosts hundreds of international visiting scientists annually. We understand the unique passport and visa documentation needs of the scientific community — including J-1, H-1B, and O-1 visa passport requirements." },
  ],
  internalLinks: [
    { name: "Fast passport services in Santa Fe, NM", route: "/santa-fe" },
    { name: "Expedited passport in Albuquerque, NM", route: "/albuquerque" },
    { name: "Urgent passport services in Espanola, NM", route: "/espanola" },
    { name: "New Mexico passport services overview", route: "/new-mexico" },
  ],
  fpcOfficeAddress: "700 E San Antonio Ave, Suite 200N, El Paso, TX 79901",
  fpcOfficeNote: "Fast Passport Center serves Los Alamos via secure registered courier with direct access to the El Paso Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Los Alamos residents can ship from the Los Alamos Post Office, the White Rock Post Office, or any UPS Store/FedEx Office in Santa Fe.",
  fpcOfficeDistance: "Serving Los Alamos, White Rock, Espanola, Pojoaque, Nambe, Tesuque, Chimayo, and all Los Alamos County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Los Alamos and Los Alamos County. From the LANL technical areas to the downtown Central Avenue district, from the White Rock residential community to the Barranca Mesa neighborhoods — we serve the entire Pajarito Plateau. Our courier service eliminates the need to drive hours to a passport agency.",
  nearbyCitiesIntro: "We serve Los Alamos and all surrounding communities including White Rock, Espanola, Pojoaque, Santa Fe, Nambe, Tesuque, and Chimayo. We also serve LANL employees commuting from Santa Fe and Albuquerque. Albuquerque International Sunport (ABQ) is approximately 100 miles south for international departures.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Los Alamos as simple as possible — with the precision and reliability LANL scientists and Los Alamos County residents expect. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Los Alamos travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Los Alamos travelers encounter unique passport issues — everything from security clearance documentation requirements to international conference timing constraints. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Los Alamos travelers — from LANL research scientists to White Rock families to NNSA contractors — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Los Alamos, NM? Here are the most common ones we hear from Pajarito Plateau travelers.",
  statePageRoute: "/states/new-mexico",
  statePageName: "New Mexico",
  servicesIntro: "Whether you need a renewal before an international physics conference, an emergency passport for a short-notice NNSA deployment, or a first-time passport for a LANL postdoc heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.losalamosnm.us/government/departments/administrative_services/motor_vehicle_division",
  dmvLabel: "Los Alamos County MVD — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "LANL international collaboration meeting at CERN in 3 days? NNSA emergency deployment to an allied facility? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Los Alamos-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Los Alamos residents renew fast — no agency visit required for most renewals. Perfect for LANL scientists, NNSA personnel, and Los Alamos County professionals preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Los Alamos residents through every step — from LANL to White Rock — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms including DS-64. We guide you through everything needed to avoid costly mistakes — so your international collaboration or conference presentation is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Los Alamos family trip or sabbatical abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for LANL professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for LANL scientists, NNSA contractors, and visiting researchers who travel internationally while their primary passport is in visa processing for multiple countries.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Pajarito Plateau travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for northern NM residents who visit Mexico or Canada.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Los Alamos NM", description: "Urgent passport processing for Los Alamos New Mexico travelers with immediate departure needs from Albuquerque Sunport." },
    { name: "Expedited Passport Renewal Los Alamos NM", description: "Fast passport renewal for Los Alamos New Mexico residents with a previously-issued passport." },
    { name: "First-Time Passport Los Alamos NM", description: "New passport application services for Los Alamos New Mexico residents applying for their first passport." },
    { name: "Child Passport Los Alamos NM", description: "Minor passport services for Los Alamos New Mexico families with children under 16." },
    { name: "Name Change Passport Los Alamos NM", description: "Passport name correction after marriage, divorce, or legal name changes for Los Alamos residents." },
    { name: "Second Passport Los Alamos NM", description: "Second passport services for LANL scientists and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Dr. Sarah K.",
      location: "Los Alamos (LANL)",
      rating: 5,
      text: "I was invited to present at a plasma physics conference in Germany with 8 days notice. My passport had expired and I was in full panic mode. Fast Passport Center got it back in 48 hours. They understood the urgency of scientific conference deadlines perfectly.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Michael R.",
      location: "Los Alamos (NNSA)",
      rating: 5,
      text: "Got called for a short-notice deployment to a UK facility for a joint project. The document review caught a photo issue I never would have noticed. Passport arrived in 4 days. The remote process meant I never had to leave the lab during a critical experiment.",
      service: "Passport Renewal",
    },
    {
      name: "The Chen Family",
      location: "White Rock",
      rating: 5,
      text: "We planned a family sabbatical in Japan — both kids needed first passports. Fast Passport Center provided a clear checklist and walked us through the White Rock Post Office acceptance process. All four passports arrived in 7 days. Seamless experience.",
      service: "Family Passport Services",
    },
    {
      name: "Dr. Elena V.",
      location: "Los Alamos (Postdoc)",
      rating: 5,
      text: "International postdoc starting at LANL with a fellowship in France beginning in 3 weeks. Needed a name change and renewal simultaneously. They caught a marriage certificate issue and got everything processed in 6 days. Lifesavers for international researchers.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "la-1",
      name: "Los Alamos Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "199 Central Park Sq",
      city: "Los Alamos",
      state: "NM",
      zip: "87544",
      phone: "(505) 662-8161",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Downtown Los Alamos",
      website: "https://tools.usps.com/find-location.htm?location=1376542",
      websiteLabel: "USPS Location",
      notes: "Main passport acceptance facility in Los Alamos. Photo services on-site. Serves downtown and the LANL community. Appointment strongly recommended — this is the primary facility for LANL employees and Los Alamos County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "la-2",
      name: "White Rock Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "139 Longview Dr",
      city: "White Rock",
      state: "NM",
      zip: "87547",
      phone: "(505) 672-9613",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "White Rock — Los Alamos County",
      website: "https://tools.usps.com/find-location.htm?location=1377573",
      websiteLabel: "USPS Location",
      notes: "Convenient for White Rock residents and families. Photo services available. Less busy than the downtown Los Alamos location — may have shorter wait times. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "la-3",
      name: "Los Alamos County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1000 Central Ave, Suite 240",
      city: "Los Alamos",
      state: "NM",
      zip: "87544",
      phone: "(505) 662-8010",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Los Alamos — County Municipal Building",
      website: "https://www.losalamosnm.us/government/departments/county_clerk",
      websiteLabel: "Los Alamos County Clerk",
      notes: "Official county clerk passport acceptance facility. Serves all of Los Alamos County. No photo services on-site — bring completed passport photos. Convenient downtown location near LANL.",
      icon: "ri-government-line",
    },
    {
      id: "la-4",
      name: "Espanola Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1011 Calle Rivera",
      city: "Espanola",
      state: "NM",
      zip: "87532",
      phone: "(505) 753-3474",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Espanola — 20 miles northeast",
      website: "https://tools.usps.com/find-location.htm?location=1367588",
      websiteLabel: "USPS Location",
      notes: "Alternative facility for Los Alamos residents who are in Espanola for shopping or errands. Photo services available. Serves Espanola Valley communities including Pojoaque, Nambe, and Chimayo.",
      icon: "ri-mail-line",
    },
    {
      id: "la-5",
      name: "Santa Fe Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 S Federal Pl",
      city: "Santa Fe",
      state: "NM",
      zip: "87501",
      phone: "(505) 988-2239",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Santa Fe — 35 miles southeast",
      website: "https://tools.usps.com/find-location.htm?location=1377569",
      websiteLabel: "USPS Location",
      notes: "Larger facility 35 miles from Los Alamos. Full photo services. Convenient for Los Alamos residents heading to Santa Fe for the day — can combine acceptance with errands. More appointment availability than Los Alamos.",
      icon: "ri-mail-line",
    },
    {
      id: "la-6",
      name: "Albuquerque Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1135 Broadway Blvd NE",
      city: "Albuquerque",
      state: "NM",
      zip: "87101",
      phone: "(505) 346-6937",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Albuquerque — 100 miles south",
      website: "https://tools.usps.com/find-location.htm?location=1376531",
      websiteLabel: "USPS Location",
      notes: "Largest facility in New Mexico. Full photo services. Convenient for Los Alamos residents heading to ABQ Sunport — can stop for acceptance on the way to the airport. Saturday hours may be available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to El Paso Passport Agency (330 miles) or Denver (400 miles)", fpc: "Most Los Alamos travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "NM-Specific Guidance", agency: "Generic — no LANL, NNSA, or scientific community expertise", fpc: "Full LANL/national lab/scientific community knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Conference Registration Without Valid Passport",
      description: "LANL scientists often register for international conferences months in advance but do not check passport validity until the week before departure. A single error or expired passport can mean missing a major presentation. We review your passport the moment you register, not when you pack.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Security Clearance Documentation Confusion",
      description: "LANL and NNSA personnel sometimes assume their DOE badge or security clearance documentation can substitute for passport requirements. It cannot. We ensure you have the correct civilian passport documentation separate from your clearance materials.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Visa Processing Time Not Factored Into Passport Timeline",
      description: "LANL international visitors and postdocs often underestimate the total timeline: passport first, then visa application. A two-week passport delay cascades into a missed visa appointment and delayed start date. We help you plan both processes.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards for Scientific Conference Badges",
      description: "Some LANL travelers submit conference badge photos thinking they meet passport standards. They do not. Passport photos are strictly regulated — 2x2 inches, white background, no glasses, neutral expression. We catch this before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming Los Alamos Post Office Has Walk-In Availability",
      description: "The Los Alamos Post Office is a small facility serving a community with high international travel demand. Walk-in passport acceptance is rarely available. We help you schedule your appointment at the most convenient facility — Los Alamos, White Rock, or Santa Fe.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your LANL office, home on Barranca Mesa, or anywhere." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your specific travel situation — scientific, government, or personal." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Los Alamos clients ship from the Central Park Square Post Office, White Rock Post Office, or from home." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive hours to El Paso, Denver, or any other passport agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No long-distance driving, no agency appointment anxiety — just your passport delivered to Los Alamos." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Los Alamos?", a: "We offer Los Alamos-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Los Alamos?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Los Alamos Post Office, White Rock Post Office, or County Clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport." },
    { q: "Where can I get passport acceptance in Los Alamos?", a: "Los Alamos County has acceptance at the Main Post Office (Central Park Square), the White Rock Post Office (Longview Dr), and the Los Alamos County Clerk (Central Ave). Espanola and Santa Fe also have facilities within a short drive. We maintain an updated list with hours and appointment options." },
    { q: "What is the closest passport agency to Los Alamos?", a: "The closest passport agency is the El Paso Passport Agency at 700 E San Antonio Ave, El Paso, TX — approximately 330 miles south. The Denver Passport Agency is about 400 miles north. Neither is practical for Los Alamos residents. Our courier channel eliminates the need to travel to any agency." },
    { q: "Can you help LANL scientists with urgent conference travel?", a: "Yes. We regularly assist LANL researchers, postdocs, and staff scientists with expedited passports for international conferences, collaboration meetings, and short-notice travel to facilities like CERN, ITER, and international partner laboratories. We understand the scientific community's unique timeline pressures." },
    { q: "What documents do Los Alamos applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Los Alamos-specific checklist." },
    { q: "Can LANL international visitors use your service?", a: "Our expedited passport services are for U.S. citizens. For international visiting scientists at LANL, we recommend contacting your home country's consulate for passport services. We can advise on U.S. passport requirements for any family members who are U.S. citizens." },
    { q: "How do I get a passport photo in Los Alamos?", a: "The Los Alamos Main Post Office and White Rock Post Office offer photo services on-site. Smith's (751 Trinity Dr) also offers passport photos. The nearest CVS and Walgreens are in Espanola (20 miles). We recommend calling ahead to confirm photo service availability." },
    { q: "How do I check my passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Los Alamos to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with passports for DOE/NNSA contractor official travel?", a: "For official government travel, you may qualify for a no-fee official passport through your agency's travel office. For personal international travel, vacation, or conferences where you are presenting as an individual (not on official orders), you need a standard tourist passport — which is what we expedite." },
  ],
  photoLocations: [
    { name: "Los Alamos Main Post Office Photos", address: "199 Central Park Sq, Los Alamos, NM 87544", hours: "Mon–Fri 9 AM – 4:30 PM" },
    { name: "White Rock Post Office Photos", address: "139 Longview Dr, White Rock, NM 87547", hours: "Mon–Fri 9 AM – 4 PM" },
    { name: "Smith's — Los Alamos", address: "751 Trinity Dr, Los Alamos, NM 87544", hours: "Daily 6 AM – 11 PM" },
    { name: "Walgreens — Espanola", address: "710 N Riverside Dr, Espanola, NM 87532", hours: "Daily 8 AM – 10 PM" },
  ],
  dmvLocations: [
    {
      name: "Los Alamos County MVD",
      address: "1000 Central Ave, Suite 150, Los Alamos, NM 87544",
      hours: "Mon–Fri, 8:00 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. County municipal building. Appointment recommended.",
      featured: true,
    },
    {
      name: "New Mexico MVD — Espanola",
      address: "1200 N Riverside Dr, Espanola, NM 87532",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Full-service MVD office 20 miles from Los Alamos. REAL ID available. Larger facility with more availability.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LAM",
      name: "Los Alamos County Airport",
      distance: "About 2 miles east of downtown Los Alamos",
      address: "135 NM-502, Los Alamos, NM 87544",
      note: "General aviation airport with limited commercial service. Most international travelers use ABQ (Albuquerque) or SAF (Santa Fe) for scheduled departures.",
      flightUrl: "https://www.losalamosnm.us/government/departments/airport",
      flightLabel: "LAM Airport Website",
      featured: true,
    },
    {
      code: "SAF",
      name: "Santa Fe Regional Airport",
      distance: "About 40 miles southeast of Los Alamos",
      address: "121 Aviation Dr, Santa Fe, NM 87507",
      note: "Regional airport with American Eagle and United Express service to DFW, DEN, and PHX — major international connecting hubs. Convenient 40-minute drive from Los Alamos.",
      flightUrl: "https://flysantafe.com/",
      flightLabel: "SAF Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New Mexico Department of Health. Online, mail, or in-person options available for Los Alamos County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NM Department of Health Vital Records. Required for estate and legal matters in Los Alamos County.",
      url: "https://www.nmhealth.org/about/erd/bvrhs/vrp/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Los Alamos County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.losalamosnm.us/government/departments/county_clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the First Judicial District Court (Santa Fe). Required for name change passport corrections.",
      url: "https://firstdistrictcourt.nmcourts.gov/",
    },
  ],
};